import { AxiosResponse } from 'axios'
import { Toastr } from 'components/global/Toastr'
import {
  ATSFiltersValues,
  initialAnalyticsValue,
} from 'containers/authorised/Analysis/ATSStatistics/utils'
import { DataProps } from 'redux/analysis/helper'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'
import { GetJobDetailAnalyticsReponse } from './types'

type InitialStateType = {
  chart: {
    id: number
    name: string
    name_i18n: string
    description: string
    description_i18n: string
    identifier: string
    module: string
    type: string
  }
  data: DataProps[]
  filters: string[]
  keys?: {
    [key: string]: string
  }
  fetching: boolean
  filter_values: ATSFiltersValues
}

const initialState: InitialStateType = {
  fetching: false,
  filter_values: initialAnalyticsValue,
  chart: {
    id: 0,
    name: '',
    name_i18n: '',
    description: '',
    description_i18n: '',
    identifier: '',
    module: '',
    type: '',
  },
  keys: {},
  data: [],
  filters: [],
}

export default function reducer(
  state = initialState,
  action: Action<AxiosResponse<GetJobDetailAnalyticsReponse> | ATSFiltersValues>,
): InitialStateType {
  switch (action.type) {
    case actions.GET_JOB_DETAIL_ANALYTICS_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.GET_JOB_DETAIL_ANALYTICS_FULFILLED: {
      return {
        ...state,
        ...(action.payload as AxiosResponse<GetJobDetailAnalyticsReponse>)?.data.data,
        fetching: false,
      }
    }

    case actions.SET_JOB_DETAIL_FILTERS: {
      return {
        ...state,
        filter_values: action.payload as ATSFiltersValues,
      }
    }

    case actions.GET_JOB_DETAIL_ANALYTICS_REJECTED: {
      // @ts-expect-error -- it is proper AxiosResponse type
      Toastr.error(handleResponseErr({ response: action.payload }))
      return {
        ...state,
        fetching: false,
      }
    }
    default:
      return state
  }
}
